/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M9.625 8.5h-.592l-.21-.203A4.853 4.853 0 0010 5.125 4.875 4.875 0 105.125 10a4.853 4.853 0 003.172-1.178l.203.21v.593l3.75 3.742 1.117-1.117L9.625 8.5zm-4.5 0A3.37 3.37 0 011.75 5.125 3.37 3.37 0 015.125 1.75 3.37 3.37 0 018.5 5.125 3.37 3.37 0 015.125 8.5z" _fill="#000" fill-opacity=".4"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/search.js